import './appRouter.scss'
import React, { Component, lazy } from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import { isInternalTechAdmin, isInternalBusAdmin, isExternalPartnerAdmin, isInternalDeveloper } from './utils/authUtil'
import { Container } from 'react-bootstrap';
import CustomAlert from './components/public/custom-alert';
import Logout from './components/common/logout';

const ViewApiSpecs = lazy(() => import('./components/restricted/api-spec/view-api-specs'));
const ViewProductSpecifications = lazy(() => import('./components/restricted/company/api-spec/view-product-specifications'));
const ViewSpecifications = lazy(() => import('./components/restricted/api-spec/view-specifications'));
const ViewApiProducts = lazy(() => import('./components/restricted/api-products/view-api-products'));
const CreateApiProduct =  lazy(() => import('./components/restricted/api-products/create-api-product'));
const UpdateApiProduct = lazy(() => import('./components/restricted/api-products/update-api-product'));
const ApiSpecification = lazy(() => import('./components/restricted/api-spec/api-specification'));
const CreateApiAccessRequest = lazy(() => import('./components/restricted/api-spec/create-api-access-request'));
const ViewApiAccessRequests = lazy(() => import('./components/restricted/api-access/view-api-access-requests'));
const CreateServiceAccount = lazy(() => import('./components/restricted/company/service-account/create-service-account'));
const ConfirmServiceAccount = lazy(() => import('./components/restricted/company/service-account/confirm-service-account'));
const CreateApplication = lazy(() => import('./components/restricted/company/application/create-application'));
const CloneApplication = lazy(() => import('./components/restricted/company/application/clone-application'));
const CreateNotification = lazy(() => import('./components/restricted/notification/create-notification'));
const ViewNotifications = lazy(() => import('./components/restricted/notification/view-notifications'));
const ViewCompanies = lazy(() => import('./components/restricted/company/view-companies'));
const CreateCompany = lazy(() => import('./components/restricted/company/create-company'));
const AddCompanyApiProducts = lazy(() => import('./components/restricted/company/add-company-api-products'));
const ViewCompanyInfo = lazy(() => import('./components/restricted/company/view-company/view-company-info'));
const CreateAPISpecification = lazy(() => import('./components/restricted/company/api-spec/create-api-specification'));
const ViewSpecificationDetail = lazy(() => import('./components/restricted/company/api-spec/view-specification-detail'));
const UpdateAPISpecification = lazy(() => import('./components/restricted/company/api-spec/update-api-specification'));
const UpdateAPISpecificationConfirmPage = lazy(() => import('./components/restricted/company/api-spec/update-api-specification-confirmation'));
const ViewCompanyApplicationSpecification = lazy(() => import('./components/restricted/company/view-company/view-company-application-specifications'));
const ViewApiProductDetails = lazy(() => import('./components/restricted/api-products/view-api-product-details'));
const CreateUser = lazy(() => import('./components/restricted/company/view-company/create-user/create-user'));
const CreateCompanyApplications = lazy(() => import('./components/restricted/company/view-company/create-application/create-application-company'));
const CloneCompanyApplications = lazy(() => import('./components/restricted/company/view-company/create-application/clone-application-company'));

class AppRouter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      headerInfo: [],
      isTechAdmin: false,
      isBusAdmin: false,
      isPartnerAdmin: false
    };
  }

  async componentDidMount() {
    const isIntTechAdmin = await isInternalTechAdmin();
    const isIntBusAdmin = await isInternalBusAdmin();
    const isExtPartnerAdmin = await isExternalPartnerAdmin();
    const isIntDeveloper = await isInternalDeveloper();

    this.setState({
      isBusAdmin: isIntBusAdmin,
      isTechAdmin: isIntTechAdmin,
      isPartnerAdmin: isExtPartnerAdmin,
      isIntDeveloper: isIntDeveloper
    })
  }

  handleClose = () => {
    this.setState({ isBusAdmin: false, isTechAdmin: false, isPartnerAdmin: false });
  }

  isRestrictedPath = () => {
    if (this.state.isBusAdmin) {
      return false;
    } else if (this.state.isTechAdmin) {
      switch (window.location.pathname) {
        case '/restricted/company/service-account/create-service-account':
          return true;
        case '/restricted/company/service-account/confirm-service-account':
          return true;
        case '/restricted/company/:companyId/user':
          return true;
        default:
          return false;
      }
    }
    else if (this.state.isPartnerAdmin) {
      switch (window.location.pathname) {
        case '/restricted/company/service-account/create-service-account':
          return true;
        case '/restricted/company/service-account/confirm-service-account':
          return true;
          case '/restricted/company/add-api-products':
            return true;
        case '/restricted/notification/view-notifications':
          return true;
        case '/restricted/api-spec/view-specifications':
          return true;
        case '/restricted/api-spec/view-product-specifications':
          return true;
        case '/restricted/notification/create-notification':
          return true;
        case '/restricted/api-access/view-api-access-requests':
          return true;
        case '/restricted/company/create-company':
          return true;
        case '/restricted/company/api-spec/create-api-specification':
          return true;
        case '/restricted/api-products/create-api-product':
          return true;
          case '/restricted/api-products/:productId/update-api-product':
          return true;
          case '/restricted/api-products/update-api-product-confirmation':
          return true;
        case '/restricted/company/api-spec/create-api-specification-confirmation':
          return true;
        case '/restricted/company/api-spec/:specId/view-specification-detail':
          return true;                    
        case '/restricted/company/api-spec/update-api-specification':
          return true;
        case '/restricted/company/api-spec/update-api-specification-confirmation':
          return true;
        case '/restricted/companies/:companyId/applications/:applicationId/view-specifications':
          return true;
        case '/restricted/api-products/view-api-product-details/:productId':
          return true;
        case '/restricted/company/:companyId/user':
          return true;
        default:
          return false;
      }
    } else if (this.state.isIntDeveloper) {
      switch (window.location.pathname) {
        case '/restricted/company/service-account/create-service-account':
          return true;
        case '/restricted/company/service-account/confirm-service-account':
          return true;
          case '/restricted/company/add-api-products':
            return true;
        case '/restricted/notification/view-notifications':
          return true;
        case '/restricted/api-spec/view-specifications':
          return true;
        case '/restricted/api-spec/view-product-specifications':
          return true;
        case '/restricted/notification/create-notification':
          return true;
        case '/restricted/api-access/view-api-access-requests':
          return true;
        case '/restricted/company/create-company':
          return true;
        case '/restricted/company/api-spec/create-api-specification':
          return true;
        case '/restricted/api-products/create-api-product':
          return true;
          case '/restricted/api-products/:productId/update-api-product':
          return true;
          case '/restricted/api-products/update-api-product-confirmation':
          return true;
        case '/restricted/company/api-spec/create-api-specification-confirmation':
          return true;
        case '/restricted/company/api-spec/:specId/view-specification-detail':
          return true;                    
        case '/restricted/company/api-spec/update-api-specification':
          return true;
        case '/restricted/company/api-spec/update-api-specification-confirmation':
          return true;
        case '/restricted/company/:companyId/user':
          return true;
        case '/restricted/company/application/access-request/create-application':
          return true;
        case '/restricted/company/application/access-request/clone-application':
          return true;
        default:
          return false;
      }
    } 

  }

  render() {

    const RoleBasedRoute = () => {
      return (
        this.props.authState.isAuthenticated ?

          (this.state.isTechAdmin || this.state.isBusAdmin) ?
            <BusTechAdminRoute /> :
          (this.state.isPartnerAdmin) ?
            <PartnerAdminRoute /> :
          <InternalDeveloperRoute />
          : <Route render={() => <Redirect to="/" />} />
      );
    }

    const BusTechAdminRoute = () => {
      return (
        this.isRestrictedPath()
          ?
          <Container className="appRouter">
            <CustomAlert customStyle='mb-30' onClose={this.handleClose} variant='danger'>
              Unable to process this request. User is not authorized to access this resource.
          </CustomAlert>
          </Container>
          :
          <Switch>
            <Route path="/restricted/api-spec/view-api-specs" exact={true} component={ViewApiSpecs} />
            <Route path="/restricted/api-spec/view-specifications" exact={true} component={ViewSpecifications} />
            <Route path="/restricted/api-products/view-api-products" exact={true} component={ViewApiProducts}/>
            <Route path="/restricted/api-products/create-api-product" exact={true} component={CreateApiProduct}/>
            <Route path="/restricted/api-products/:productId/update-api-product" exact={true} component={UpdateApiProduct}/>
            <Route path="/restricted/api-spec/:specId" exact={true} component={ApiSpecification} />
            <Route path="/restricted/api-spec/:specId/create-api-access-request" exact={true} component={CreateApiAccessRequest} />
            <Route path="/restricted/api-access/view-api-access-requests" exact={true} component={ViewApiAccessRequests} />
            <Route path="/restricted/company/service-account/confirm-service-account" exact={true} component={ConfirmServiceAccount} />
            { JSON.parse(window.sessionStorage.getItem('isApiProductOwner')) && 
            <Route path="/restricted/company/service-account/create-service-account" exact={true} component={CreateServiceAccount} />}
            <Route path="/restricted/company/application/access-request/create-application" exact={true} component={CreateApplication} />
            <Route path="/restricted/company/application/access-request/clone-application" exact={true} component={CloneApplication} />
            <Route path="/restricted/notification/create-notification" exact={true} component={CreateNotification} />
            <Route path="/restricted/notification/view-notifications" exact={true} component={ViewNotifications} />
            <Route path="/restricted/company/view-companies" exact={true} component={ViewCompanies} />
            <Route path="/restricted/company/create-company" exact={true} component={CreateCompany} />
            <Route path="/restricted/company/add-api-products" exact={true} component={AddCompanyApiProducts} />
            <Route path="/restricted/company/:companyId" exact={true} component={ViewCompanyInfo} />
            <Route path="/restricted/company/api-spec/create-api-specification" exact={true} component={CreateAPISpecification} />
            <Route path="/restricted/company/api-spec/:specId/view-specification-detail" exact={true} component={ViewSpecificationDetail} />
            <Route path="/restricted/company/api-spec/:specId/update-api-specification" exact={true} component={UpdateAPISpecification} />
            <Route path="/restricted/company/api-spec/update-api-specification-confirmation" exact={true} component={UpdateAPISpecificationConfirmPage} />
            <Route path="/restricted/company/api-spec/view-product-specifications" exact={true} component={ViewProductSpecifications} />
            <Route path="/restricted/companies/:companyId/applications/:applicationId/view-specifications" exact={true} component={ViewCompanyApplicationSpecification} />
            <Route path="/restricted/api-products/view-api-product-details/:productId" exact={true} component={ViewApiProductDetails}/>
            <Route path="/restricted/company/:companyId/user" exact={true} component={CreateUser} />
            <Route path="/restricted/company/:companyId/create-application" exact={true} component={CreateCompanyApplications} />
            <Route path="/restricted/company/:companyId/clone-application" exact={true} component={CloneCompanyApplications} />
            <Route path="/logout" exact={true} component={Logout} />
            
            <Route render={() => <Redirect to="/" />} />
          </Switch>
      )
    }

    

    const PartnerAdminRoute = () => {
      return (
        this.isRestrictedPath()
          ?
          <Container className="appRouter">
            <CustomAlert customStyle='mb-30' onClose={this.handleClose} variant='danger'>
              Unable to process this request. User is not authorized to access this resource.
          </CustomAlert>
          </Container>
          :
          <Switch>
            <Route path="/restricted/api-spec/view-api-specs" exact={true} component={ViewApiSpecs} />
            <Route path="/restricted/api-spec/:specId" exact={true} component={ApiSpecification} />
            <Route path="/restricted/company/view-companies" exact={true} component={ViewCompanies} />
            <Route path="/restricted/company/:companyId" exact={true} component={ViewCompanyInfo} />
            <Route path="/restricted/company/:companyId/create-application" exact={true} component={CreateCompanyApplications} />
            <Route path="/restricted/company/:companyId/clone-application" exact={true} component={CloneCompanyApplications} />
            <Route path="/restricted/company/api-spec/view-product-specifications" exact={true} component={ViewProductSpecifications} />
            <Route path="/restricted/api-products/view-api-product-details/:productId" exact={true} component={ViewApiProductDetails}/>
            <Route path="/restricted/companies/:companyId/applications/:applicationId/view-specifications" exact={true} component={ViewCompanyApplicationSpecification} />
            <Route path="/restricted/company/application/access-request/create-application" exact={true} component={CreateApplication} />
            <Route path="/restricted/company/application/access-request/clone-application" exact={true} component={CloneApplication} />
            <Route path="/restricted/api-spec/:specId/create-api-access-request" exact={true} component={CreateApiAccessRequest} />
            <Route path="/logout" exact={true} component={Logout} />
            <Route render={() => <Redirect to="/" />} />
          </Switch>
      );
    }

    const InternalDeveloperRoute = () => {
      return (
        this.isRestrictedPath()
          ?
          <Container className="appRouter">
            <CustomAlert customStyle='mb-30' onClose={this.handleClose} variant='danger'>
              Unable to process this request. User is not authorized to access this resource.
          </CustomAlert>
          </Container>
          :
          <Switch>
            <Route path="/restricted/api-spec/view-api-specs" exact={true} component={ViewApiSpecs} />
            <Route path="/restricted/api-spec/:specId" exact={true} component={ApiSpecification} />
            <Route path="/restricted/company/view-companies" exact={true} component={ViewCompanies} />
            <Route path="/restricted/company/:companyId" exact={true} component={ViewCompanyInfo} />
            <Route path="/restricted/company/api-spec/view-product-specifications" exact={true} component={ViewProductSpecifications} />
            <Route path="/restricted/api-products/view-api-products" exact={true} component={ViewApiProducts}/>
            <Route path="/restricted/api-products/view-api-product-details/:productId" exact={true} component={ViewApiProductDetails}/>
            <Route path="/restricted/companies/:companyId/applications/:applicationId/view-specifications" exact={true} component={ViewCompanyApplicationSpecification} />
            <Route path="/restricted/api-spec/:specId/create-api-access-request" exact={true} component={CreateApiAccessRequest} />
            <Route path="/logout" exact={true} component={Logout} />
            <Route render={() =><Redirect to="/" />} />
          </Switch>
      );
    }

    return (
      this.props.authState.isPending ? <div className='auth-pending-section'><p>Please wait ...</p></div> :
        <div>
          <RoleBasedRoute />
        </div>
    );
  }
}

export default withOktaAuth(withRouter(AppRouter));